import { Component, OnInit, Input, Output, ViewChild, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ImageCropperComponent, LoadedImage, ImageCroppedEvent } from 'ngx-image-cropper';
import { InputObject, OutputImage } from './interfaces';
import { Subject } from 'rxjs';
import { LogService } from '../../../services/log.service';

@Component({
    selector: 'edit-image',
    templateUrl: './edit-image.component.html',
    styleUrls: ['./edit-image.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditImageComponent implements OnInit {
  @ViewChild('cropper', { static: false }) cropper: ImageCropperComponent;

  @Input() inputImage: InputObject;
  @Output() getOutput = new EventEmitter();
  @Input() undoTrigger: Subject<any>;

  outputImage: OutputImage = {
    image: null,
    config: {
      crop: null,
      size: {
        width: null,
        height: null
      },
      rotate: null
    }
  };

  originalRotation: number;
  canvasRotation: number = 0;
  rotationStepDegree = 90;

  constructor(private logService: LogService) {}

  ngOnInit() {
    this.undoTrigger.subscribe(() => this.discard());

    this.inputImage.originalImage = this.inputImage.image ? this.inputImage.image : this.inputImage.url;
    if (this.inputImage.config && this.inputImage.config.rotate) {
      this.originalRotation = this.inputImage.config.rotate;
    }
  }

  imageLoaded(image: LoadedImage) {
    if (this.inputImage.config && this.inputImage.config.size) {
      this.outputImage.config.size = image.original.size;
      this.inputImage.config.size = null;
    }

    if (this.inputImage.config && this.inputImage.config.crop) {
      this.cropper.cropper = this.inputImage.config.crop;
      this.inputImage.image = this.cropper.crop().base64;
      this.inputImage.config.crop = null;
    }

    if (this.inputImage.config && this.inputImage.config.rotate) {
      this.canvasRotation = this.inputImage.config.rotate / this.rotationStepDegree;
      this.outputImage.config.rotate = this.inputImage.config.rotate;
      this.inputImage.config.rotate = null;
    }
  }

  loadImageFailed() {
    this.logService.logWarn('Loading image failed!');
  }

  imageCropped(imageCropped: ImageCroppedEvent) {
    this.outputImage.image = imageCropped.base64;
    this.outputImage.config.crop = imageCropped.cropperPosition;
    this.getOutput.emit(this.outputImage);
  }

  cropImage() {
    if (this.inputImage.image && !this.outputImage.image) {
      this.outputImage.image = this.cropper.crop().base64;
      this.outputImage.config.crop = this.cropper.cropper;
      this.inputImage.image = null;
    }
    this.getOutput.emit(this.outputImage);
  }

  discard() {
    this.inputImage.image = this.inputImage.originalImage;
    this.outputImage.image = null;
    this.outputImage.config.crop = null;
    this.outputImage.config.rotate = this.originalRotation;
    this.canvasRotation = this.originalRotation / this.rotationStepDegree;

    this.getOutput.emit(this.outputImage);
  }

  rotateImage() {
    this.canvasRotation++;
    this.outputImage.config.rotate = (this.canvasRotation * this.rotationStepDegree) % 360;
    this.getOutput.emit(this.outputImage);
  }
}
